export function ngRightClick($parse) {
    return function (scope: angular.IScope, element, attrs) {
        const fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    }
}
